import React from 'react'
import { toTimestamp } from '@hlj/hlj-utils'
import indexStore from '../../List/store'
import { JUKE_PATH_A } from '@constant'

const { point } = indexStore

const spanStyle = {
  color: '#fff',
  display: 'inline-block',
  width: 18,
  height: 18,
  borderRadius: 18,
  background: '#ff705e',
  lineHeight: '18px',
  textAlign: 'center',
  marginLeft: 10
}

export default [
  {
    title: '活动名称',
    dataIndex: 'title',
    key: 'title',
    width: 300
  },
  {
    title: '报名时间',
    dataIndex: 'time',
    key: 'time',
    render: (time, { publish_time, sign_up_end_time }) => (
      <div>
        <p>从 {publish_time.split(' ')[0]}</p>
        <p>至 {sign_up_end_time.split(' ')[0]}</p>
      </div>
    )
  },
  {
    title: '活动状态',
    dataIndex: 'active',
    key: 'active',
    width: 150,
    render: (
      active,
      { sign_up_end_time, pay_type, actual_bought_phones, create_point }
    ) => (
      <div>
        {toTimestamp(sign_up_end_time) > toTimestamp() ? (
          <div>
            <p>报名中</p>
            {(pay_type == 0 || pay_type == 1) &&
              point == 0 && (
                <p style={{ color: '#ff8c47', fontSize: 12 }}>
                  活动点不足，新用户报名通知已暂停
                </p>
              )}
            {pay_type == 2 &&
              parseInt(actual_bought_phones) >= parseInt(create_point) &&
              point == 0 && (
                <p style={{ color: '#ff8c47', fontSize: 12 }}>
                  活动点不足，新用户报名通知已暂停
                </p>
              )}
            <p />
          </div>
        ) : (
          <div>报名完成</div>
        )}
      </div>
    )
  },
  {
    title: '报名人数',
    dataIndex: 'sign_up_count',
    key: 'sign_up_count',
    render: sign_up_count => <p>{sign_up_count}人</p>
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    render: (
      operation,
      { sign_up_new_count, winner_limit, is_sign_up, sign_up_fee, id }
    ) => {
      let type
      if (winner_limit > 0 && (is_sign_up != 0 || sign_up_fee != 0)) {
        type = 'limit'
      }
      if (winner_limit == 0 && (is_sign_up != 0 || sign_up_fee != 0)) {
        type = 'nlimit'
      }

      return (
        <a href={`${JUKE_PATH_A}/enroll/${id}?type=${type}`}>
          报名信息{sign_up_new_count > 0 ? (
            <span style={spanStyle}>{sign_up_new_count}</span>
          ) : (
            ''
          )}
        </a>
      )
    }
  }
]
